export default "__VITE_ASSET__BoEjTvJ7__"